import { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import Drawer, { DrawerHeader, DrawerFooter } from 'common/components/drawer';
import { FormDrawer } from 'common/components/drawer';
import { useForm, useActions } from 'utils/hooks';
import * as laytimeEventActions from 'store/laytime-events/actions';
import { FormBody } from 'common/components/drawer';
import EditVisibilityForm from 'components/drawers/EditCompanyVisibility';
import selectDataFromState from 'utils/selectDataFromState';

import config from './laytime-event/config';
import LaytimeEvents from './laytime-event';

const EditLaytimeEvents = ({ drawer, active, editType, refetchData }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [updateLaytimeEvents, createLaytimeEvents] = useActions([
    laytimeEventActions.updateLaytimeEvents,
    laytimeEventActions.createLaytimeEvents
  ]);
  const { formState, loadValues, handleSubmitError, resetForm, collectValues } = useForm(config);
  const { isOpen } = drawer;

  useEffect(() => {
    if (active && isOpen) {
      const params = {
        ...active
      };

      const initialValues = selectDataFromState(params, config);

      loadValues({ ...initialValues });
    }

    if (!isOpen) {
      resetForm();
    }
  }, [isOpen]);

  const submit = async () => {
    const values = collectValues();
    if (!values) return;

    const { ...rest } = values;

    const params = {
      ...rest,
      table: 'laytime_events',
      id: active ? active.id : undefined
    };

    setIsSubmitting(true);

    try {
      if (active) {
        await updateLaytimeEvents(params);
      } else {
        await createLaytimeEvents(params);
        resetForm();
        refetchData();
      }

      drawer.close();
    } catch (error) {
      handleSubmitError(error);
    }

    setIsSubmitting(false);
  };

  return active && editType === 'visibility' ? (
    <EditVisibilityForm
      drawer={drawer}
      active={active}
      isOpen={drawer.isOpen}
      type="enums/laytime-events"
    />
  ) : (
    <Drawer {...drawer} className="table-drawer">
      <DrawerHeader className="border-bottom pb-4">
        {active ? 'Edit ' + active.name : 'Add New Laytime Event'}
      </DrawerHeader>

      <FormDrawer>
        <FormBody>
          <LaytimeEvents formState={formState} />
        </FormBody>
      </FormDrawer>

      <DrawerFooter className="d-flex justify-content-end p-3">
        <Button
          color="cancel"
          className="px-0 py-1 me-4"
          onClick={() => drawer.close()}
          disabled={isSubmitting}
        >
          CANCEL
        </Button>
        <Button onClick={submit} disabled={isSubmitting} color="primary" className="px-4">
          SAVE
        </Button>
      </DrawerFooter>
    </Drawer>
  );
};

export default EditLaytimeEvents;
